import { render, staticRenderFns } from "./SupervisionNotebook.vue?vue&type=template&id=0bb988cf"
import script from "./SupervisionNotebook.vue?vue&type=script&lang=js"
export * from "./SupervisionNotebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports